import service from '@/utils/request'
import {getToken} from "@/utils/auth";
// @Summary 用户登录 获取动态路由
// @Produce  application/json
// @Param 可以什么都不填 调一下即可
// @Router /menu/getMenu [post]
export const asyncMenu = () => {
  return service({
    url: 'api/getMenu',
    method: 'post',
    headers:{
      'x-token':getToken()
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/menu.js